import { Component } from "react";
import { withRouter } from "react-router-dom";
import requireAuth from "components/hoc/requireAuth";

class Dashboard extends Component {
  componentDidMount() {
    const roles = localStorage.getItem("roles");
    if (roles) {
      if (roles.includes("Manager")) {
        this.props.history.push("/dashboard/manager");
      } else {
        this.props.history.push("/dashboard/personnel");
      }
    }
  }

  render() {
    return null;
  }
}

export default withRouter(requireAuth(Dashboard));
